module.exports = __webpack_public_path__ + "media/danceing.bc379d84.mp4";